module.exports = __webpack_public_path__ + "static/media/dark-clear-betslip.4fe1cad2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dark-clear-betslip.svg
// module id = 2372
// module chunks = 7